<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加</Button>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="场次ID" :show-tooltip-when-overflow="true" width="60"></el-table-column>
        <el-table-column prop="startDate" label="开课日期" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="days" label="开课天数" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="salePrice" label="课程价格" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="city" label="开课城市" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="lecturerName" label="关联讲师" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save">
      <Form :label-width="80">
				<FormItem label="开课日期">
          <DateSelect v-model="detail.startDate"></DateSelect>
				</FormItem>
				<FormItem label="开课天数">
					<Input v-model="detail.days" type="number"/>
				</FormItem>
				<FormItem label="课程价格">
					<Input v-model="detail.salePrice" type="number"/>
				</FormItem>
				<FormItem label="开课城市">
          <Field2 :type="1" v-model="detail.cityid"></Field2>
				</FormItem>
				<FormItem label="关联讲师">
          <FieldLecturer v-model="detail.lecturerId"></FieldLecturer>
				</FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modal1=false;">取消</Button>
        <Button @click="save(1)" type="info">保存</Button>
        <Button @click="save(2)" type="primary">保存并继续添加</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
  import DateSelect from '@/public/iview/DateSelect'
  import FieldLecturer from '@/components/common/field/FieldLecturer'
  import Field2 from '@/components/common/field/Field2'
  export default {
    components:{DateSelect,FieldLecturer,Field2},
    props:['productId'],
    data(){
      return{
        baseUrl:'/api/product/productdetail/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        params.push('t.productId@=@'+this.productId);
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(flag){
        let that = this;
        this.detail.productId = this.productId;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            if(flag==1){//保存并关闭
              that.detail = {};
              that.modal1 = false;
            }else{ //继续添加
              that.detail.id = 0;
              that.detail.startDate = '';
            }
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    },
    watch:{
      productId:{
      handler(newValue, oldValue) {
        this.load();
      },
      deep: true
    }
  }

  }
</script>



// WEBPACK FOOTER //
// src/components/product/ProductDetail.vue